export const VIEW_ACCOUNTS = 'View Accounts';
export const CREATE_ACCOUNTS = 'Create Accounts';
export const UPDATE_ACCOUNTS = 'Update Accounts';
export const DELETE_ACCOUNTS = 'Delete Accounts';
export const EXPORT_ACCOUNTS = 'Export Accounts';
export const DIRECTORY_PERMISSIONS = [VIEW_ACCOUNTS, CREATE_ACCOUNTS, UPDATE_ACCOUNTS, DELETE_ACCOUNTS, EXPORT_ACCOUNTS];

export const VIEW_SEQUENCER = 'View Sequencer';
export const CREATE_STRATEGIES = 'Create Strategies';
export const BULK_CREATE_STRATEGIES = 'Bulk Create';
export const ARCHIVE_STRATEGIES = 'Archive Strategies';
export const EDIT_STRATEGIES = 'Edit Strategies';
export const RUN_STRATEGIES = 'Run Strategies';
export const DELETE_STRATEGIES = 'Delete Strategies';
export const SELECT_REMOVAL_PHASE = 'Select Removal Phase';
export const DISABLE_GLOBAL_DNC = 'Disable Global DNC';
export const DATA_SOURCE = 'Data Source';
export const OPEN_CASE_GRACE = 'Open Case Grace';
export const ACTIVITY_REPORTS = 'Activity Reports';
export const BULK_EDIT_STRATEGIES = 'Bulk Edit';
export const SEQUENCER_PERMISSIONS = [VIEW_SEQUENCER, CREATE_STRATEGIES, BULK_CREATE_STRATEGIES, ARCHIVE_STRATEGIES, EDIT_STRATEGIES, RUN_STRATEGIES, DELETE_STRATEGIES, SELECT_REMOVAL_PHASE, DISABLE_GLOBAL_DNC, DATA_SOURCE, OPEN_CASE_GRACE, ACTIVITY_REPORTS, BULK_EDIT_STRATEGIES];

export const VIEW_DNC = 'View DNC';
export const CREATE_DNC_RECORDS = 'Create DNC Records';
export const DELETE_DNC_RECORDS = 'Delete DNC Records';
export const UPLOAD_DNC_LISTS = 'Upload DNC Lists';
export const TOGGLE_GLOBAL_DNC = 'Toggle: Global DNC';
export const TOGGLE_ACCOUNT_DNC = 'Toggle: Account DNC';
export const TOGGLE_EXCLUSIVITY = 'Toggle: Exclusivity';
export const TOGGLE_CLIENT_PROVIDED = 'Toggle: Client Provided';
export const DNC_PERMISSIONS = [VIEW_DNC, CREATE_DNC_RECORDS, DELETE_DNC_RECORDS, UPLOAD_DNC_LISTS, TOGGLE_GLOBAL_DNC, TOGGLE_ACCOUNT_DNC, TOGGLE_EXCLUSIVITY, TOGGLE_CLIENT_PROVIDED];

export const VIEW_USERS = 'View Users';
export const CREATE_USERS = 'Create Users';
export const UPDATE_USERS = 'Update Users';
export const DELETE_USERS = 'Delete Users';
export const IMPERSONATE_USERS = 'Impersonate Users';
export const USER_PERMISSIONS = [VIEW_USERS, CREATE_USERS, UPDATE_USERS, DELETE_USERS, IMPERSONATE_USERS];

export const MANAGE_HEYREACH_INSTANCES = 'Manage HeyReach Instances';
export const MANAGE_HEYREACH_CAMPAIGNS = 'Manage HeyReach Campaigns';
export const MANAGE_SMARTLEAD_INSTANCES = 'Manage SmartLead Instances';
export const VIEW_DOCUMENTATION = 'View Documentation';
export const CONFIGURE_PERMISSIONS = [MANAGE_HEYREACH_INSTANCES, MANAGE_HEYREACH_CAMPAIGNS, MANAGE_SMARTLEAD_INSTANCES, VIEW_DOCUMENTATION];

export const MANAGE_SETTINGS = 'Manage Settings';
export const MANAGE_TAGS = 'Manage Tags';
export const MANAGE_API_KEYS = 'Manage API Keys';
export const SETTINGS_PERMISSIONS = [MANAGE_SETTINGS, MANAGE_TAGS, MANAGE_API_KEYS];

export const VIEW_EXTENSION_USAGE = 'View Extension Usage';
export const MANAGE_EXTENSION_VERSIONS = 'Manage Extension Versions';
export const EXTENSION_PERMISSIONS = [VIEW_EXTENSION_USAGE, MANAGE_EXTENSION_VERSIONS];

export const VIEW_SURVEY_REPORTS = 'View Survey Reports';
export const SURVEY_PERMISSIONS = [VIEW_SURVEY_REPORTS];

export const VIEW_TALK_TRACKS = 'View Talk Tracks';
export const MANAGE_TALK_TRACKS = 'Manage Talk Tracks';
export const APPROVE_TALK_TRACKS = 'Approve Talk Tracks';
export const ADHERENCE_REPORTING = 'Adherence Reporting';
export const EDIT_ADHERENCE_SCORES = 'Edit Adherence Scores';
export const USE_AI_ASSISTANT = 'Use AI Assistant';
export const AI_ASSISTANT_REPORTING = 'AI Assistant Reporting';
export const DEMO_REPORTING = 'Demo Reporting';
export const TALK_TRACK_ANALYTICS = 'Talk Track Analytics';
export const CREATE_TALK_TRACK_TEMPLATE = 'Create Talk Track Template';
export const TALK_TRACK_PERMISSIONS = [VIEW_TALK_TRACKS, MANAGE_TALK_TRACKS, APPROVE_TALK_TRACKS, TALK_TRACK_ANALYTICS, CREATE_TALK_TRACK_TEMPLATE, ADHERENCE_REPORTING, EDIT_ADHERENCE_SCORES];

export const VIEW_DATA_INGESTION = 'View Data Ingestion';
export const MANAGE_DATA_INGESTION = 'Manage Data Ingestion';
export const DATA_INGESTION_PERMISSIONS = [VIEW_DATA_INGESTION, MANAGE_DATA_INGESTION];

export const EXPORT_5X5 = '5x5 Export';
export const EXPORT_5X5_PERMISSIONS = [EXPORT_5X5];

export const VIEW_SEARCH = 'View Search';
export const EXPORT_SEARCH_RESULTS = 'Export Results';
export const ADVANCED_SEARCH = 'Advanced Search';
export const SUPPRESS_EXPORTS = 'Suppress Exports';
export const PRIMARY_TABLES = 'Primary Tables';
export const LEADMAGIC = 'LeadMagic';
export const ELEVATED_CREDIT_USE = 'Elevated Credit Use';
export const LEADMAGIC_PERMISSIONS = [ELEVATED_CREDIT_USE];
export const SEARCH_SURVEY = 'Survey';
export const PROSPECT_SEARCH_PERMISSIONS = [VIEW_SEARCH, EXPORT_SEARCH_RESULTS, ADVANCED_SEARCH, SUPPRESS_EXPORTS, PRIMARY_TABLES, LEADMAGIC, SEARCH_SURVEY];

export const EMAIL_VALIDATION = 'Email Validation';
export const VALIDATION_PERMISSIONS = [EMAIL_VALIDATION];

export const VIEW_SMARTPIXL = 'View SmartPiXL';
export const ADD_SMARTPIXL_DEALERS = 'Add SmartPiXL Dealers';
export const UPDATE_SMARTPIXL_DEALERS = 'Update SmartPiXL Dealers';
export const EXPORT_SMARTPIXL_METRICS = 'Export SmartPiXL Metrics';
export const EXPORT_SMARTPIXL_LEADS = 'Export SmartPiXL Leads';
export const SMARTPIXL_PERMISSIONS = [VIEW_SMARTPIXL, ADD_SMARTPIXL_DEALERS, UPDATE_SMARTPIXL_DEALERS, EXPORT_SMARTPIXL_METRICS, EXPORT_SMARTPIXL_LEADS];

export const VIEW_VISITOR_RESOLUTION_PIXEL = 'View Visitor Resolution Pixel';
export const EXPORT_VISITOR_RESOLUTION_PIXEL = 'Export Visitor Resolution Pixel';
export const MANAGE_PIXEL_SETTINGS = 'Manage Pixel Settings';
export const VISITOR_RESOLUTION_PIXEL_PERMISSIONS = [VIEW_VISITOR_RESOLUTION_PIXEL, EXPORT_VISITOR_RESOLUTION_PIXEL, MANAGE_PIXEL_SETTINGS];

export const VIEW_CALLS = 'View Calls';
export const TRANSCRIBE_CALLS = 'Transcribe Calls';
export const CALLS_PERMISSIONS = [VIEW_CALLS, TRANSCRIBE_CALLS];

export const APPOINTMENT_EMAILS = 'Appointment Emails';
export const REGENERATE_APPOINTMENT_EMAILS = 'Regenerate Emails';
export const APPOINTMENT_CALLS = 'Appointment Calls';
export const EXPORT_ALL_APPOINTMENT_CALLS = 'Download All Appointment Calls';
export const SUBMIT_SALESMANSHIP_SCORECARD = 'Submit Salesmanship Scorecard';
export const APPOINTMENTS_PERMISSIONS = [APPOINTMENT_EMAILS, REGENERATE_APPOINTMENT_EMAILS, APPOINTMENT_CALLS, EXPORT_ALL_APPOINTMENT_CALLS, SUBMIT_SALESMANSHIP_SCORECARD];

// UI labels for permissions whose stored key no longer matches the page name. Keys stay as-is: the server matches on them.
export const PERMISSION_LABELS = {
  [APPOINTMENT_CALLS]: 'Account Management Hub',
  [EXPORT_ALL_APPOINTMENT_CALLS]: 'Bulk Export Hub Calls',
};

export const permissionLabel = (permission) => PERMISSION_LABELS[permission] || permission;

export const PERMISSION_GROUPS = {
  'Directory': DIRECTORY_PERMISSIONS,
  'Sequencer': SEQUENCER_PERMISSIONS,
  'DNC': DNC_PERMISSIONS,
  'Users': USER_PERMISSIONS,
  'Configure': CONFIGURE_PERMISSIONS,
  'Settings': SETTINGS_PERMISSIONS,
  'Extension': EXTENSION_PERMISSIONS,
  'Surveys': SURVEY_PERMISSIONS,
  'Talk Tracks': TALK_TRACK_PERMISSIONS,
  'AI Assistant': [USE_AI_ASSISTANT, AI_ASSISTANT_REPORTING],
  'Reps Demo': [DEMO_REPORTING],
  'Calls / Transcripts': CALLS_PERMISSIONS,
  'Appointments': APPOINTMENTS_PERMISSIONS,
  'Data Ingestion': DATA_INGESTION_PERMISSIONS,
  '5x5 Export': EXPORT_5X5_PERMISSIONS,
  'Prospect Search': PROSPECT_SEARCH_PERMISSIONS,
  'Validation': VALIDATION_PERMISSIONS,
  'LeadMagic': LEADMAGIC_PERMISSIONS,
  'SmartPiXL': SMARTPIXL_PERMISSIONS,
  'Visitor Resolution Pixel': VISITOR_RESOLUTION_PIXEL_PERMISSIONS,
};
